import { Logger } from '@yarmill/types';

export async function streamMessage(
  stream: ReadableStream<Uint8Array>,
  logger: Logger,
  oneMessageChunkReceived: (message: string[]) => void,
  onDone?: () => void
): Promise<void> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();

  const readChunk = async () => {
    try {
      const { done, value } = await reader.read();

      if (done) {
        reader.releaseLock();
        onDone?.();
      } else {
        const stringValue = decoder.decode(value, { stream: true });
        const split = stringValue.split('\n');
        oneMessageChunkReceived?.(split);
        await readChunk();
      }
    } catch (error) {
      logger.error(error);
      onDone?.();
    }
  };

  await readChunk();
}
